import React from "react";
import { StatusChip, StatusChipProps } from "@pushpress/shared-components";
import type { AttendanceStatus } from "../../../graphql/graphql-generated.types";
import {
  attendanceStatusColor,
  attendanceStatusLabel,
} from "./AttendanceReport.utils";

interface AttendanceStatusProps extends Pick<StatusChipProps, "size"> {
  status: AttendanceStatus;
}

const AttendanceStatus = (props: AttendanceStatusProps) => {
  const { status, size } = props;
  const label = attendanceStatusLabel[status];
  const color = attendanceStatusColor[status];
  return <StatusChip label={label} size={size} color={color} />;
};

export default AttendanceStatus;
